import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetUserQuery } from 'src/common/slices';
import { CampaignsProps } from './campaigns.types';
import { checkIfShouldShow } from './helpers';
export const Campaigns: FC<CampaignsProps> = ({
  config,
  children
}) => {
  const {
    name
  } = config;
  const {
    pathname
  } = useLocation();
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const shouldShow = useMemo(() => {
    const {
      pathsToExclude,
      pathsToInclude
    } = config;
    const canShow = config.canShow ? config.canShow(pathname, userDataResponse?.data) : true;
    return canShow && checkIfShouldShow(pathsToExclude || [], pathsToInclude || [], pathname);
  }, [pathname, config, userDataResponse]);
  return shouldShow ? children(name) : null;
};